/**
 * AI 取名报告服务
 *
 * 契约（与后端约定）：
 * - POST /api/ai/naming/analyze  登录+计费（feature='naming'），请求体数理字段
 *   全部由前端 shunshi 移植引擎算好传入；响应 { success, report, report_id, consumed }
 * - GET  /api/ai/naming/history  登录，返回最近 20 条
 *
 * 走统一 client.js 的 aiApi 实例（LLM 分析 20-30s+，需 90s 超时），
 * 响应拦截器已拆包 response.data。
 */
import { aiApi } from '@/api/client'

/** 生成 AI 取名报告 */
export function analyzeNaming(payload) {
  return aiApi.post('/api/ai/naming/analyze', payload)
}

/** 最近 20 条历史报告 */
export function getNamingHistory() {
  return aiApi.get('/api/ai/naming/history')
}

export default { analyzeNaming, getNamingHistory }
